const apiURL = require('./apiURL');

// types of action
const Types = {
  CALCULATION_READY: "CALCULATION_READY",
  CALCULATION_REPORT_REQUESTED: "CALCULATION_REPORT_REQUESTED",
  CALCULATION_REPORT_SENT: "CALCULATION_REPORT_SENT",
  CALCULATION_FILE_UPLOADING: "CALCULATION_FILE_UPLOADING",
  CALCULATION_FILE_UPLOADED: "CALCULATION_FILE_UPLOADED"
};

const colaIncreases = {
  '2023': {
    'Hour': 0.2475,
    'Day': 1.98,
    'Week': 9.9,
    'Month': 42.9,
    'Year': 514.8
  },
  '2024': {
    'Hour': 0.32025,
    'Day': 2.562,
    'Week': 12.81,
    'Month': 55.51,
    'Year': 666.12,
    'estimated': false
  },
  '2025': {
    'Hour': 0.131,
    'Day': 1.048,
    'Week': 5.24,
    'Month': 22.7066666667,
    'Year': 272.48,
    'estimated': false
  },
  '2026': {
		'Hour': 0.1165,
		'Day': 0.932,
		'Week': 4.66,
		'Month': 20.1933333333,
		'Year': 242.32,
		'estimated': false,
	},
  '2027': {
		'Hour': 0,
		'Day': 0,
		'Week': 0,
		'Month': 0,
		'Year': 0,
		'estimated': false,
	},
  '2028': {
		'Hour': 0,
		'Day': 0,
		'Week': 0,
		'Month': 0,
		'Year': 0,
		'estimated': false,
	}
}

const minimumWage = {
    '2023': {
        increaseAfterYearsOfService:{
            1: 3,
            2: 3,
        },
        // setup using age so that we factor in data that is organised differently
        'age': {
            '16': {
                'Week': 183.11
            },
            '17':{
                'Week': 185.95,
            },
            '18':{
                'Hour': 4.81825,
                'Day': 38.546,
                'Week': 192.73,
                'Month': 835.1633,
                'Year': 10021.96,
            }
        }
    },
    '2024': {
        increaseAfterYearsOfService:{
            1: 3,
            2: 3,
        },
        // setup using age so that we factor in data that is organised differently
        'age': {
            '16': {

            },
            '17':{

            },
            '18':{
                'Hour': 5.3385,
                'Day': 42.708,
                'Week': 213.54,
                'Month': 925.34,
                'Year': 11104.08,
            }
        }
    },
    '2025': {
        increaseAfterYearsOfService:{
            1: 3,
            2: 3,
        },
        // setup using age so that we factor in data that is organised differently
        'age': {
            '16': {

            },
            '17':{

            },
            '18':{
                'Hour': 5.5445,
                'Day': 44.356,
                'Week': 221.78,
                'Month': 961.04666666667,
                'Year': 11532.56,
            }
        }
    },
    '2026': {
        increaseAfterYearsOfService:{
            1: 3,
            2: 3,
        },
        // setup using age so that we factor in data that is organised differently
        'age': {
            '16': {

            },
            '17':{

            },
            '18':{
                "Hour": 5.6805,
                "Day": 45.444,
                "Week": 227.22,
                "Month": 984.62,
                "Year": 11815.44,
            }
        }
    }
}

const calculationReady = (data, cola) => ({
  type: Types.CALCULATION_READY,
  data,
  cola
});

const calculateSalary = (payslipData) => {
  return async (dispatch, getState) => {

    const path = `/calculator/salary`
    let cola

    if (payslipData.cola || (payslipData.comparisonYear && ["506", "507"].includes(String(payslipData.taxStatus)))) {
      await fetch(apiURL + path, {
        method: 'POST',
        body: JSON.stringify(payslipData),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(response => response.json())
        .then(data => {
          console.log(data)
          cola = data
        })

      if (payslipData.year >= 2022) payslipData.year++

      if (payslipData.cola) {
        payslipData.amount = payslipData.amount + (colaIncreases?.[payslipData.year]?.[payslipData.frequency] || 0)
      }

      // check against minimum wage and increase if needed
      console.log('minimumWage[payslipData.year]',minimumWage[payslipData.year],payslipData.year)
        if (minimumWage[payslipData.year] && payslipData.amount < minimumWage[payslipData.year].age['18'][payslipData.frequency]) {
            payslipData.amount = minimumWage[payslipData.year].age['18'][payslipData.frequency]
        }
    }

    if (!colaIncreases?.[payslipData.year]?.[payslipData.frequency]) {
      payslipData.cola = false;
      payslipData.year -= 1;
    }
    
    if (payslipData.comparisonYear && ["506", "507"].includes(String(payslipData.taxStatus))) {
        payslipData.year = payslipData.comparisonYear;
    }

    fetch(apiURL + path, {
      method: 'POST',
      body: JSON.stringify(payslipData),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(data => {
        if (colaIncreases[payslipData.year].estimated){
          data.estimated = true
        }
        console.log(data)
        dispatch(calculationReady(data, cola))
      })
  }
}

const setFileUploading = (file) => ({
  type: Types.CALCULATION_FILE_UPLOADING,
  file
});

const setFileUploaded = (payload) => ({
  type: Types.CALCULATION_FILE_UPLOADED,
  payload
});

const downloadColaTemplate = () => {
  return (dispatch, getState) => {

    fetch(apiURL + '/calculator/cola/upload', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        window.open(data.template, '_blank')
      })
      .catch(error => console.error(error))
  }
}

const uploadCola = ({ file }) => {
  return (dispatch, getState) => {
    const state = getState();

    const path = '/calculator/cola/upload';

    // NotificationManager.success('Your File is being uploaded','Info')
    dispatch(setFileUploading(file.name));

    fetch(apiURL + path, {
      method: 'POST',
      body: JSON.stringify({
        name: file.name,
        type: file.type,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const initialResponse = data
        fetch(data.url, {
          method: 'PUT',
          body: file,
          headers: {
            Accept: 'application/json',
            'Content-Type': file.type,
          },
        })
          .then(() => dispatch(setFileUploaded(initialResponse.key)))
      })
      .catch(error => console.error(error))
  };
};

const savingLead = ({ name }) => ({
  type: Types.CALCULATION_REPORT_REQUESTED,
  name
});

const savedLead = ({ url, name }) => ({
  type: Types.CALCULATION_REPORT_SENT,
  url,
  name
});

const clearReportLink = ({name}) => ({
    type: Types.CALCULATION_REPORT_SENT,
    url: null,
    name
})


const getStepFunctionState = ({
  arn,
  name,
}) => {
  return (dispatch, getState) => {

    const state = getState()

    const path = `/calculator/report/${arn}`

    fetch(apiURL + path, {
      // credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {

        const finished = data.data.status != "RUNNING"
        console.debug(name)

        if (finished) {

          if (data.data && data.data.output) {
            const output = JSON.parse(data.data.output)
            dispatch(savedLead({ url: output.url, name }))
          }

        } else {

          setTimeout(
            () => {
              dispatch(getStepFunctionState({ arn, name }))
            },
            1000
          )
        }

      })
  }
}


const requestReport = (data, label) => {
  return (dispatch, getState) => {

    if (data.payslipInput.cola) {
      if (data.payslipInput.year >= 2022) data.payslipInput.year++

      data.payslipInput.amount = data.payslipInput.amount + colaIncreases[data.payslipInput.year][data.payslipInput.frequency]

      if (minimumWage[data.payslipInput.year] && data.payslipInput.amount < minimumWage[data.payslipInput.year].age['18'][data.payslipInput.frequency]) {
          data.payslipInput.amount = minimumWage[data.payslipInput.year].age['18'][data.payslipInput.frequency]
      }
    }


    const state = getState()
    dispatch(savingLead({ name: 'generateSamplePayslip' }))

    fetch(apiURL + '/calculator/salary/report', {
      // credentials: 'include',
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        // dispatch(savedLead(data,label))

        const arn = data.executionArn
        // dispatch(getLeaveBalance())

        setTimeout(
          () => {
            dispatch(getStepFunctionState({ arn, name: 'generateSamplePayslip' }))
          },
          1000
        )
        // dispatch(contactInList({email: data.email}))
      })
  }
}

const requestColaReport = (data, label) => {
  return (dispatch, getState) => {

    // just forward all no need to extract
    // const {email,name,surname,phone,organisation,noOfEmployees,list} = data

    const state = getState()
    dispatch(savingLead({ name: 'GenerateColaReport' }))

    fetch(apiURL + '/calculator/cola/report', {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        /*'Organisation': getState().currentOrganisation,*/
      },
    })
      .then(response => response.json())
      .then(data => {
        // dispatch(savedLead(data,label))
        console.log(data)
        const arn = data.executionArn
        // dispatch(getLeaveBalance())

        setTimeout(
          () => {
            dispatch(getStepFunctionState({ arn, name: 'GenerateColaReport' }))
          },
          1000
        )
        // dispatch(contactInList({email: data.email}))
      })
  }
}



const Actions = {
  calculateSalary,
  requestReport,
  uploadCola,
  downloadColaTemplate,
  requestColaReport,
  colaIncreases,
    minimumWage,
    clearReportLink
}

export { Types, Actions }
